import React, { useState } from 'react';
import propTypes from 'prop-types';
import {
  Button,
  Columns,
  Column,
  ModalCardBody,
  ModalCardHeader,
  ModalCardTitle,
  ModalCard,
  ModalBackground,
  Modal,
  ModalContent,
} from 'src/ui/mui-ui-kit';
import { usePoseWithBulma } from 'src/ui/hooks';
import { Form, Field } from 'react-final-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FadeInDiv, AnimatedCard, InnerLoader, UiInputAdapter } from 'src/ui';
import { required } from 'src/ui/validations';

export function SubmitConsentModal({ consent, onSubmit, onClickCancel }) {
  const [loading, setLoading] = useState(false);
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    !!consent.name
  );

  async function submit(values) {
    setLoading(true);

    const result = await onSubmit(values);

    setLoading(false);

    return result;
  }

  return (
    <Form
      /* eslint-disable-next-line react/jsx-no-bind */
      onSubmit={submit}
      render={({ handleSubmit, hasValidationErrors }) => (
        <Modal isActive={isModalVisible} className="submit-consent-modal">
          <ModalBackground
            tag={FadeInDiv}
            pose={currentPose}
            onPoseComplete={onPoseComplete}
          />
          <ModalContent>
            <div className="has-text-right">
              <Button
                isColor="text"
                isSize="small"
                onClick={onClickCancel}
                className="close"
              >
                <span className="icon has-text-white">
                  <FontAwesomeIcon icon={['fal', 'times-circle']} size="2x" />
                </span>
              </Button>
            </div>
            <ModalCard tag={AnimatedCard} pose={currentPose}>
              <InnerLoader visible={loading} />
              <ModalCardHeader>
                <ModalCardTitle
                  tag="h5"
                  className="has-text-weight-semibold has-text-primary"
                >
                  <span className="has-text-grey-medium-dark">Consent | </span>
                  {consent.name}
                </ModalCardTitle>
              </ModalCardHeader>
              <ModalCardBody
                className="content has-text-grey-medium-dark"
                /* eslint-disable-next-line */
                dangerouslySetInnerHTML={{
                  __html: consent.longDescription,
                }}
              />
            </ModalCard>
            <Columns isVCentered className="initials-fields">
              <Column className="has-text-right">
                <label
                  htmlFor="initials"
                  className="has-text-weight-semibold is-size-5 has-text-white"
                >
                  Initials
                </label>
              </Column>
              <Column isSize="narrow">
                <Field
                  component={UiInputAdapter}
                  name="initials"
                  id="initials"
                  required
                  validate={required('Initials')}
                  hideHelp
                  maxLength="2"
                />
              </Column>
              <Column isSize="narrow">
                <Button
                  onClick={handleSubmit}
                  disabled={hasValidationErrors}
                  isColor="gradient-bright"
                  className="is-long"
                >
                  I Consent
                </Button>
              </Column>
            </Columns>
          </ModalContent>
        </Modal>
      )}
    />
  );
}

SubmitConsentModal.defaultProps = {
  consent: {},
};

SubmitConsentModal.propTypes = {
  consent: propTypes.shape({
    name: propTypes.string,
    longDescription: propTypes.string,
  }),
  onSubmit: propTypes.func.isRequired,
  onClickCancel: propTypes.func.isRequired,
};
